__turbopack_context__.v({
  "className": "noto_sans_arabic_e36d9751-module__FkSewq__className",
  "variable": "noto_sans_arabic_e36d9751-module__FkSewq__variable",
});
